export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10351.b63ab502.jpg";